import { BanknoteArrowUpIcon, CreditCard, HandCoins, Hospital, Landmark, SquareLibrary } from 'lucide-react';
import { tv, type VariantProps } from 'tailwind-variants';
import { cn } from '@/app/_lib/utils/utils';
import type { FeaturedHeroCards } from '@/app_data/mock/ndrData';

const featuredCardsVariants = tv({
  slots: {
    cardIcon: 'h-6 text-blue-500 w-6',
    cardItem: 'flex gap-sm p-6 border border-gray-200 rounded-sm shadow-sm',
    cardsGrid: 'col-span-full grid gap-xl md:grid-cols-3',
    cardTitle: 'typography-level-5 font-medium',
    container: 'flex flex-col layout-gap-md',
    headerSection: 'flex flex-col gap-sm',
    subtitle: 'typography-level-6',
    title: 'font-semibold typography-level-4',
  },
});

interface FeaturedCardsProps extends VariantProps<typeof featuredCardsVariants> {
  className?: string;
  data: FeaturedHeroCards;
}

const ICON_MAP: Record<string, React.ElementType> = {
  banknoteArrowUp: BanknoteArrowUpIcon,
  creditCard: CreditCard,
  handCoins: HandCoins,
  hospital: Hospital,
  landmark: Landmark,
  squareLibrary: SquareLibrary,
} as const;

const FeaturedCards = ({ className = '', data }: FeaturedCardsProps) => {
  const slots = featuredCardsVariants({});

  return (
    <div className={cn(slots.container(), className)}>
      <div className={slots.headerSection()}>
        <h4 className={slots.title()}>{data.title}</h4>
        <p className={slots.subtitle()}>{data.subtitle}</p>
      </div>
      <div className={slots.cardsGrid()}>
        {data.items.map((card) => {
          const IconComponent = ICON_MAP[card.iconName];

          if (!IconComponent) {
            return null;
          }

          return (
            <div
              className={slots.cardItem()}
              key={card.iconName}
            >
              <IconComponent
                aria-hidden='true'
                className={slots.cardIcon()}
              />
              <h5 className={slots.cardTitle()}>{card.title}</h5>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { FeaturedCards };
